import { useParams } from "react-router";
import RisikoanalyseStepForm from "./RisikoanalyseStepForm";

/**
 * Internal Risikoanalyse-Step page. Same step-form als der (entfernte)
 * /public/customer-risk-analysis-step-form/:token Pfad, aber gerendert
 * innerhalb der AppShell mit Navigations-Sidebar (auto-collapsed via
 * NavigationLayout regex).
 *
 * Route: /contacts/:contactId/risikoanalyse-step
 *
 * Daten leben direkt auf Contact (Beratermodus-Spalten). Vor PR XX wurden
 * sie als PublicFormToken mit formType='risikoanalyse-step' gefuehrt;
 * Migration 202605250001 zieht Bestandsdaten rueber.
 */

const RisikoanalyseStepInternalPage = () => {
  const { contactId } = useParams<{ contactId: string }>();
  const contactIdNum = contactId ? parseInt(contactId, 10) : NaN;

  if (!contactId || Number.isNaN(contactIdNum)) {
    return null;
  }

  return (
    <RisikoanalyseStepForm
      internalMode
      internalContactId={contactIdNum}
      welcomeStoragePrefix="risikoanalyse-step-internal-welcome-seen:"
      draftStoragePrefix="risikoanalyse-step-internal-draft:"
      submitVersion="internal-step-form-v2"
      internalReturnPath={`/contacts/${contactId}`}
    />
  );
};

export default RisikoanalyseStepInternalPage;
